<template>
  <div class="d-flex">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click.stop="onRemove(item)">
          <v-icon left>mdi-delete</v-icon>
          <v-list-item-title>Xóa</v-list-item-title>
        </v-list-item>
        <v-list-item @click.stop="disableStaff">
          <v-icon left>mdi-lock</v-icon>
          <v-list-item-title>Khóa</v-list-item-title>
        </v-list-item>
        <v-list-item @click.stop="enableStaff">
          <v-icon left>mdi-lock-open-outline</v-icon>
          <v-list-item-title>Mở khóa</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    disabled: Boolean,
    item: {
      type: [Object],
      default: () => {}
    }
  },
  computed: {
    ...mapState('staff', ['staffs']),
  },
  methods: {
    ...mapActions('staff', [
      'removeStaff',
      'updateStaff',
    ]),
    disableStaff () {
      this.updateStaff({ id: this.item.id, status: 'block' })
    },
    enableStaff () {
      this.updateStaff({ id: this.item.id, status: 'active' })
    },
    onRemove(staff) {
      this.$dialog.confirm({
        title: 'Thông báo xác nhận',
        text:
        'Bạn có chắc chắn muốn xóa Nhân viên này? Bạn không thể hoàn tác hành động',
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          await this.removeStaff(staff)
        },
      })
    },

  }
}
</script>
